module.exports = __webpack_public_path__ + "static/media/sueli-maria.25f91724.png";